import React from "react";
import WeatherDetail from "./WeatherDetail";

const WeatherCard = ({ data }) => {
  if (!data) return null;

  const {
    name,
    sys: { country },
    weather,
    main: { temp, feels_like, humidity },
    wind: { speed },
  } = data;

  const iconUrl = `https://openweathermap.org/img/wn/${weather[0].icon}@2x.png`;

  return (
    <article className="weather-card card" aria-label={`Weather in ${name}`}>
      {/* Location */}
      <div className="weather-location">
        <h2 className="weather-city">{name}</h2>
        <p className="weather-country">{country}</p>
      </div>

      {/* Main: icon + temperature */}
      <div className="weather-main">
        <img
          src={iconUrl}
          alt={weather[0].description}
          className="weather-icon"
          width="80"
          height="80"
        />
        <p className="weather-temp">
          {Math.round(temp)}
          <span className="weather-temp-unit">°C</span>
        </p>
      </div>

      {/* Description */}
      <p className="weather-description">{weather[0].description}</p>

      {/* Details Grid */}
      <div className="weather-details" role="list" aria-label="Weather details">
        <WeatherDetail
          icon="🌡️"
          value={`${Math.round(feels_like)}°`}
          label="Feels Like"
        />
        <WeatherDetail
          icon="💧"
          value={`${humidity}%`}
          label="Humidity"
        />
        <WeatherDetail
          icon="💨"
          value={`${speed} m/s`}
          label="Wind"
        />
      </div>
    </article>
  );
};

export default WeatherCard;
